/* The size drawing (roadmap FL, 2026-10-13): the sizes nested on one wall, with hover, size buttons, the caption and
   the wall controls. It takes over the markup that snippets/jh-size-nest.liquid renders and keeps its own state per
   drawing, so two drawings on one page do not touch each other. Nothing here reads the buy box: a caller drives it
   with set(), and hears the shopper's picks through the onPick option. The product pages use a small bridge in
   sections/jhilke-formats.liquid; the Sizing guide uses its own picker (assets/jhilke-sizing-guide.js).
   Every number is written with setAttribute, style.setProperty or textContent. Nothing is built from strings of markup.

   JhNest(figure, options) returns { set(part, glow), get(), info() }
   options.state     start values: { w, h, p, size (index), finish, label, orient }
   options.controls  element holding the wall controls ([data-fm="w"], [data-fm="h"], [data-fm="p"], [data-fm-out])
   options.labels    { finish: words } for the caption, when set() gives no label
   options.depthKinds  finishes whose depth the caption names (default framed, hanger, acrylic)
   options.noOverallKinds  finishes whose caption names no overall size, only the depth (default none)
   options.onPick(i) the shopper picked size i (chip or drawing). Without it the drawing selects the size itself.
   options.onChange(state) called after set() changed something */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var LIM = { w: [100, 800, 300], h: [150, 500, 250], p: [150, 200, 170] };

  function fmt(n) { return String(Math.round(n * 10) / 10); }
  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }
  function geo(el, o) { Object.keys(o).forEach(function (k) { el.setAttribute(k, o[k]); el.style.setProperty(k, o[k] + 'px'); }); }
  function finOf(fig) {
    var out = {};
    (fig.dataset.fin || '').split('|').forEach(function (row) {
      var p = row.split(':');
      if (p[0]) out[p[0]] = { aw: Number(p[1]) || 0, ah: Number(p[2]) || 0, d: p[3] || '' };
    });
    if (!out.matte) out.matte = { aw: 0, ah: 0, d: '' };
    return out;
  }

  function JhNest(fig, opts) {
    opts = opts || {};
    var FIN = finOf(fig);
    var stage = fig.querySelector('[data-fm-stage]');
    var svg = stage.querySelector('svg');
    var surf = stage.querySelector('[data-fm-surface]');
    var tag = stage.querySelector('[data-fm-tag]');
    var cap = fig.querySelector('[data-fm-cap]');
    var ctl = opts.controls || null;
    var chips = Array.prototype.slice.call(fig.querySelectorAll('.jh-fm__chip'));
    var groups = [];
    svg.querySelectorAll('.jh-fm__print').forEach(function (g) { groups[Number(g.dataset.i)] = g; });
    var face = svg.querySelector('.jh-fm__face');
    var floor = svg.querySelector('.jh-fm__floor');
    var sofa = svg.querySelector('.jh-fm__sofa');
    var person = svg.querySelector('.jh-fm__person');
    if (!chips.length || !surf || chips.length !== groups.length) return null;
    var depthKinds = opts.depthKinds || ['framed', 'hanger', 'acrylic'];
    var noOverall = opts.noOverallKinds || [];
    var baseOrient = fig.dataset.orient === 'landscape' ? 'landscape' : 'portrait';
    var base = chips.map(function (c) { return [Number(c.dataset.w), Number(c.dataset.h)]; });
    var curIndex = chips.findIndex(function (c) { return c.dataset.size === fig.dataset.cur; });
    var st = { w: 300, h: 250, p: 170, size: curIndex < 0 ? 0 : curIndex, finish: fig.dataset.kind || 'matte', label: fig.dataset.finish || '', orient: baseOrient };
    Object.keys(opts.state || {}).forEach(function (k) { st[k] = opts.state[k]; });

    // Caption: aria-live, written at most every 300 ms so a dragged slider does not flood a screen reader
    var capText = '', capLast = 0, capTimer = 0;
    function capWrite() { capLast = Date.now(); if (cap && cap.textContent !== capText) cap.textContent = capText; }
    function capQueue() { var wait = 300 - (Date.now() - capLast); if (wait <= 0) capWrite(); else if (!capTimer) capTimer = setTimeout(function () { capTimer = 0; capWrite(); }, wait); }

    function dims(i) { var b = base[i]; return st.orient === baseOrient ? [b[0], b[1]] : [b[1], b[0]]; }
    var placed = [], boxes = [], hoverI = null, last = null;

    function render(glow) {
      var gk = FIN[st.finish] ? st.finish : 'matte';
      var g = FIN[gk];
      var W = st.w, H = st.h, P = st.p;
      var sofaOn = W >= 240;
      var nestX = sofaOn ? 125 : W / 2;
      var rows = chips.map(function (c, i) { var d = dims(i); return { i: i, pw: d[0], ph: d[1], ow: d[0] + g.aw, oh: d[1] + g.ah, cur: i === st.size }; });
      var cur = rows[st.size] || rows[0];
      var half = cur.oh / 2;
      var tallest = Math.max.apply(null, rows.map(function (x) { return x.oh; }));
      // Centre 145 cm up; chosen bottom at or above 100 cm; largest outline 10 cm under the ceiling. The ceiling wins.
      var hang = 145;
      if (hang < 100 + half) hang = 100 + half;
      if (hang > H - 10 - tallest / 2) hang = H - 10 - tallest / 2;
      var nestY = H - hang;
      var maxOw = Math.max.apply(null, rows.map(function (x) { return x.ow; }));
      fig.dataset.kind = gk;
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + (H + 12));
      svg.style.setProperty('--fm-u', String(Math.round((W / 250) * 1000) / 1000));
      var b0 = svg.getBoundingClientRect();
      var sc0 = Math.min(b0.width / W, b0.height / (H + 12));
      var fsU = Math.round(Math.max(9, W / 32, sc0 > 0 ? 12.4 / sc0 : 0) * 100) / 100;
      svg.style.setProperty('--fm-fs', String(fsU));
      svg.style.setProperty('--fm-fsm', String(fsU));
      face.setAttribute('width', W); face.setAttribute('height', H);
      floor.setAttribute('y1', H); floor.setAttribute('x2', W); floor.setAttribute('y2', H);
      sofa.setAttribute('transform', 'translate(-15 ' + (H - 250) + ')');
      if (sofaOn) sofa.removeAttribute('display'); else sofa.setAttribute('display', 'none');
      person.style.transform = 'translate(' + (W - 20 - (19 * P) / 170) + 'px, ' + H + 'px) scale(' + P / 170 + ')';
      placed = [];
      rows.forEach(function (r) {
        var grp = groups[r.i];
        var inset = r.cur && gk === 'framed' ? 0.6 : 0;
        var left = nestX - r.ow / 2;
        var top = nestY - r.oh / 2;
        var was = grp.classList.contains('is-current');
        grp.classList.toggle('is-current', r.cur);
        // A wall too short for this outline plus 20 cm: leave it out, never the chosen one
        if (!r.cur && r.oh + 20 > H) grp.setAttribute('display', 'none'); else grp.removeAttribute('display');
        var bars = grp.querySelectorAll('.jh-fm__bar');
        geo(grp.querySelector('.jh-fm__r'), { x: left + inset, y: top + inset, width: r.ow - 2 * inset, height: r.oh - 2 * inset });
        geo(grp.querySelector('.jh-fm__wrap'), { x: left + 2, y: top + 2, width: r.ow - 4, height: r.oh - 4 });
        geo(bars[0], { x: left, y: top, width: r.ow });
        geo(bars[1], { x: left, y: top + r.oh - 2.1, width: r.ow });
        placed.push({ i: r.i, x: left, y: top, w: r.ow, h: r.oh, hidden: grp.getAttribute('display') === 'none' });
        var tx = grp.querySelector('text');
        tx.setAttribute('text-anchor', 'start');
        // The letters stack in a column just outside the largest outline's right edge, the largest at its bottom edge
        var rank = rows.filter(function (o) { return o.oh > r.oh || (o.oh === r.oh && o.ow > r.ow); }).length;
        tx.style.transform = 'translate(' + (nestX + maxOw / 2 + 6) + 'px, ' + (nestY + tallest / 2 + fsU * 0.35 - rank * fsU * 1.35) + 'px)';
        // One soft glow on the frame that was just chosen
        if (glow && r.cur && !was && matchMedia('(prefers-reduced-motion: no-preference)').matches) {
          grp.classList.remove('is-glow');
          if (grp.getAnimations) grp.getAnimations().forEach(function (a) { a.cancel(); });
          grp.classList.add('is-glow');
          grp.addEventListener('animationend', function () { grp.classList.remove('is-glow'); }, { once: true });
        }
      });
      chips.forEach(function (c, i) {
        var d = dims(i);
        c.querySelector('span').textContent = d[0] + ' × ' + d[1];
        c.dataset.w = String(d[0]); c.dataset.h = String(d[1]);
        c.setAttribute('aria-pressed', i === st.size ? 'true' : 'false');
      });
      place();
      if (ctl) {
        var wi = ctl.querySelector('[data-fm="w"]'), hi = ctl.querySelector('[data-fm="h"]'), pi = ctl.querySelector('[data-fm="p"]'), out = ctl.querySelector('[data-fm-out]');
        if (wi && document.activeElement !== wi) wi.value = String(W);
        if (hi && document.activeElement !== hi) hi.value = String(H);
        if (pi && pi.value !== String(P)) pi.value = String(P);
        if (out) out.textContent = P + ' cm';
      }
      var label = st.label || (opts.labels && opts.labels[st.finish]) || st.finish;
      var tail = depthKinds.indexOf(st.finish) >= 0 && g.d ? ', ' + g.d + ' cm deep' : '';
      var lead = chips[cur.i].dataset.name + ', ' + cur.pw + ' × ' + cur.ph + ' cm. ';
      var wall = '. On a ' + W + ' × ' + H + ' cm wall' + (sofaOn ? ' above a 2 m sofa' : '') + ', beside a person ' + P + ' cm tall.';
      if (noOverall.indexOf(st.finish) >= 0) capText = lead + label + (tail || '') + wall;
      else capText = lead + label + ': ' + fmt(cur.ow) + ' × ' + fmt(cur.oh) + ' cm overall' + tail + wall;
      capQueue();
      last = { index: cur.i, pw: cur.pw, ph: cur.ph, ow: cur.ow, oh: cur.oh, depth: g.d, finish: gk, orient: st.orient };
    }

    // One pointer surface over the drawing. The outlines nest on one centre, so a tap or mouse move picks the outline
    // whose EDGE is nearest (distance to each rectangle's border, not its area). Boxes are kept in stage pixels.
    function place() {
      var vb = svg.viewBox && svg.viewBox.baseVal;
      var sr = svg.getBoundingClientRect();
      var tr = surf.getBoundingClientRect();
      if (!vb || !sr.width || !vb.width) return;
      var k = Math.min(sr.width / vb.width, sr.height / vb.height);
      var ox = sr.left - tr.left + (sr.width - vb.width * k) / 2;
      var oy = sr.top - tr.top + (sr.height - vb.height * k) / 2;
      boxes = placed.map(function (p) { return { i: p.i, hidden: p.hidden, x: ox + p.x * k, y: oy + p.y * k, w: p.w * k, h: p.h * k }; });
      if (hoverI !== null) setHover(hoverI);
    }
    function edge(b, px, py) {
      var dx = Math.max(b.x - px, 0, px - (b.x + b.w));
      var dy = Math.max(b.y - py, 0, py - (b.y + b.h));
      if (dx || dy) return Math.hypot(dx, dy);
      return Math.min(px - b.x, b.x + b.w - px, py - b.y, b.y + b.h - py);
    }
    // The S, M and L letters sit outside the outlines, so a tap on a letter (its box padded 10 px on every side, at least
    // 24 px tall) picks that size before the nearest-edge rule runs.
    function letterHit(px, py) {
      var tr = surf.getBoundingClientRect(), hit = null, bd = Infinity;
      groups.forEach(function (g, i) {
        if (g.getAttribute('display') === 'none') return;
        var q = g.querySelector('text').getBoundingClientRect();
        var padY = Math.max(10, (24 - q.height) / 2);
        var l = q.left - tr.left - 10, rr = q.right - tr.left + 10, tp = q.top - tr.top - padY, bt = q.bottom - tr.top + padY;
        if (px >= l && px <= rr && py >= tp && py <= bt) { var d = Math.hypot(px - (l + rr) / 2, py - (tp + bt) / 2); if (d < bd) { bd = d; hit = i; } }
      });
      return hit;
    }
    function nearest(px, py) {
      var onLetter = letterHit(px, py);
      if (onLetter !== null) return onLetter;
      var best = null, bd = Infinity;
      boxes.forEach(function (b) { if (b.hidden) return; var d = edge(b, px, py); if (d < bd) { bd = d; best = b; } });
      return best ? best.i : null;
    }
    function setHover(i) {
      var box = i !== null ? boxes.find(function (b) { return b.i === i && !b.hidden; }) : null;
      groups.forEach(function (g, gi) { g.classList.toggle('is-hover', Boolean(box) && gi === i); });
      if (!box) { hoverI = null; tag.hidden = true; return; }
      hoverI = i;
      var c = chips[i];
      tag.textContent = c.dataset.name + ', ' + c.dataset.w + ' × ' + c.dataset.h + ' cm';
      tag.hidden = false;
      tag.style.left = Math.round(box.x + box.w / 2) + 'px';
      tag.style.top = Math.round(box.y + box.h + 4) + 'px';
    }
    function pick(i) {
      if (opts.onPick) opts.onPick(i); else api.set({ size: i }, true);
    }
    function at(e) { var r = surf.getBoundingClientRect(); return nearest(e.clientX - r.left, e.clientY - r.top); }
    surf.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') setHover(at(e)); });
    surf.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') setHover(null); });
    surf.addEventListener('click', function (e) { var i = at(e); if (i !== null) pick(i); });
    chips.forEach(function (c, i) { c.addEventListener('click', function () { pick(i); }); });
    // The keyboard path is the size buttons: focusing one shows its outline and tag
    fig.addEventListener('focusin', function (e) { var c = e.target instanceof Element ? e.target.closest('.jh-fm__chip') : null; if (c && c.matches(':focus-visible')) setHover(Number(c.dataset.i)); });
    fig.addEventListener('focusout', function (e) { if (e.target instanceof Element && e.target.closest('.jh-fm__chip')) setHover(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setHover(null); });

    // The wall controls, when the caller gives them: clamped on change, never while typing
    function setNum(key, raw) { var lim = LIM[key]; var text = String(raw).trim(); var n = text === '' ? st[key] : Number(text); st[key] = clamp(Math.round(Number.isFinite(n) ? n : lim[2]), lim[0], lim[1]); }
    if (ctl) {
      ['w', 'h', 'p'].forEach(function (k) { var el = ctl.querySelector('[data-fm="' + k + '"]'); if (el) setNum(k, el.value); });
      ctl.addEventListener('input', function (e) { if (e.target.dataset.fm === 'p') { setNum('p', e.target.value); render(false); } });
      ctl.addEventListener('change', function (e) { var k = e.target.dataset.fm; if (k === 'w' || k === 'h') { setNum(k, e.target.value); e.target.value = String(st[k]); render(false); } });
    }

    var api = {
      set: function (part, glow) {
        var changed = false;
        Object.keys(part).forEach(function (k) { if (st[k] !== part[k]) { st[k] = part[k]; changed = true; } });
        if (changed) render(Boolean(glow) && 'size' in part);
        if (opts.onChange && changed) opts.onChange(api.get());
        return api;
      },
      get: function () { var o = {}; Object.keys(st).forEach(function (k) { o[k] = st[k]; }); return o; },
      info: function () { return last; }
    };
    render(false);
    capWrite();
    // The letters: the drawing is scaled to fit its box, so the font size in drawing units is chosen to render at 12.4 px or more.
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        place();
        var vb = svg.viewBox.baseVal, bx = svg.getBoundingClientRect(), sc = Math.min(bx.width / vb.width, bx.height / vb.height);
        if (!sc) return;
        var want = Math.round(Math.max(9, vb.width / 32, 12.4 / sc) * 100) / 100;
        if (Math.abs(want - parseFloat(svg.style.getPropertyValue('--fm-fs'))) > 0.05) render(false);
      }).observe(svg);
    }
    return api;
  }
  JhNest.NS = NS;
  window.JhNest = JhNest;
})();
